import React from "react";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";
import { Box, Typography } from "@mui/material";
import EMPButton from "../../shared/components/EMPButton/EMPButton";
import MotionChevronRightCircle from "../../shared/Icons/MotionChevronRightCircle";
import MotionCautionIcon from "../../shared/Icons/MotionCautionIcon";
import styles from "./ProtectionPlansEpaAccordion.module.scss";

const ProtectionPlansEpaAccordion = ({ hasSavedRouteOneId }) => {
  const { t } = useTranslation();

  return (
    <Box
      className={styles.container}
      data-testid="protection-plans-epa-accordion"
    >
      {!hasSavedRouteOneId && (
        <Box className={styles.warningBanner} data-testid="epa-warning-banner">
          <MotionCautionIcon
            sx={{ color: "#B16201", fontSize: 24, marginRight: 4 }}
          />
          <Typography variant="body2" className={styles.warningText}>
            <Trans
              i18nKey="DealerOnboarding.content.protectionPlans.epa.warningText"
              components={{ bold: <strong /> }}
            />
          </Typography>
        </Box>
      )}

      <Typography variant="body1" className={styles.copy}>
        <Trans
          i18nKey="DealerOnboarding.content.protectionPlans.epa.description"
          components={{ bold: <strong />, br: <br /> }}
        />
      </Typography>

      <EMPButton
        href={t("DealerOnboarding.content.protectionPlans.epa.acceptButtonURL")}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.actionButton}
        testId="protection-plans-epa-accept-button"
        variant="contained"
        hasRightIcon
        rightIcon={<MotionChevronRightCircle />}
        disabled={!hasSavedRouteOneId}
      >
        {t("DealerOnboarding.content.protectionPlans.epa.acceptButton")}
      </EMPButton>
    </Box>
  );
};

ProtectionPlansEpaAccordion.propTypes = {
  hasSavedRouteOneId: PropTypes.bool,
};

export default ProtectionPlansEpaAccordion;
